import {Component, Input, ViewEncapsulation, Injector, OnInit} from '@angular/core';
import { Module } from 'projects/common/model/ModuleModel';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { ModuleService } from 'projects/common/services/module.service';
import { AbstractComponent } from '../../abstract.component';
import { ButtonOptions } from '../../eva-button/eva-button.component';
import { PictureData } from '../../picture/picture.component';
import { TagTextData } from '../../tag-text/tag-text.component';

@Component({
  selector: 'text-and-image',
  template: `
    <text *ngIf="module.pretitle || module.title || module.subtitle" [data]="module" class="-eva-3-mb-xlg"></text>

    <div class="text-and-image-container {{containerStyle}} {{module.data.options?.text_side || 'LEFT'}}" *ngIf="module.data">
      <ng-container *ngTemplateOutlet="text"></ng-container>
      <ng-container *ngTemplateOutlet="image"></ng-container>
    </div>
    <ng-template #text>
      <div class="text-and-image-container-child text-container"
        [ngStyle]="{'justify-content': module.data.options?.text_align, 'max-height': hideText ? module.data.options?.max_height : 'inherit'}"
        [ngClass]="{'full-text': !module.data.picture,
          'view-less': module.data.options?.max_height && hideText,
          'view-more': module.data.options?.max_height && !hideText}">

        <div class="text-and-button-container">
          <text [data]="{title: this.module.data.title, text_data: this.module.data.text}"></text>
          <eva-button *ngIf="module.data.button" [options]="module.data.button"
                      [moduleId]="getModuleId()" [uniqueId]="module.unique_id"
                      [moduleIndex]="module.row_number"></eva-button>
        </div>

        <div *ngIf="module.data.options?.max_height" class="button-toggle-heigth">
          <eva-button class="button-container"
          [options]="{'icon': hideText ? 'chevron-down' : 'chevron-up', 'link_text': (hideText ? 'common.viewMore' : 'common.viewLess') | translate, 'type': '-link'}"
          [moduleId]="getModuleId()" [uniqueId]="module.unique_id" [moduleIndex]="module.row_number" (clickEvent)="hideText = !hideText"></eva-button>
        </div>
      </div>
    </ng-template>
    <ng-template #image>
      <div class="text-and-image-container-child image-container" *ngIf="module.data.picture">
        <picture class="picture-image-container">
          <img ngClass="picture {{pictureStyle}}"
               [alt]="module.data.picture.alt || module.data.picture.alt_mobile"
               [src]="pictureSrc + imageSize"
               loading="lazy"
          >
        </picture>
      </div>
    </ng-template>
  `,
  styleUrls: ['./text-and-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextAndImageComponent extends AbstractComponent implements OnInit {
  private static MODULE_ID = 'TextAndImageModule';

  @Input() override module: Module<TextAndImageModel>;

  pictureSrc?: string;
  pictureStyle = '';
  containerStyle = '';
  hideText: boolean = true;

  desktopImageSize: string = "700x550";
  mobileImageSize: string = "570x428";
  imageSize: string = '';

  constructor(injector: Injector, private mediaPictureService: MediaPictureService, private moduleService: ModuleService) {
    super(injector);
  }

  ngOnInit(): void {
    this.pictureSrc = this.module.data.picture
      && this.mediaPictureService.getMediaUrlByPictureData(this.module.data.picture, this.screenType);
    this.updateContainerAndPictureClass();

    if (this.moduleService.isRestrictResources(TextAndImageComponent.MODULE_ID) && !this.mediaPictureService.getImageSize(this.pictureSrc)) {
      this.imageSize = '/' + (this.screenType == 'MOBILE' ? this.mobileImageSize : this.desktopImageSize);
    }
  }

  getModuleId() {
    return TextAndImageComponent.MODULE_ID;
  }

  updateContainerAndPictureClass() {
    const viewType = this.module.data.options?.view_type || TextAndImageViewType.DEFAULT;
    switch (viewType) {
      case TextAndImageViewType.WITHOUT_BACKGROUND:
        this.containerStyle = this.module.data.picture ? 'space-between' : '';
        this.pictureStyle = 'border-radius';
        break;
      case TextAndImageViewType.DEFAULT:
      default:
        this.containerStyle = 'eva-3-card -eva-3-shadow-line';
        this.pictureStyle = '';
    }
  }
}

export interface TextAndImageModel {
  title: TagTextData;
  text: TagTextData;
  picture?: PictureData;
  button?: ButtonOptions;
  options?: TextAndImageOptions;
}

export interface TextAndImageOptions {
  text_align?: string;
  view_type?: TextAndImageViewType;
  text_side: 'LEFT' | 'RIGHT' | 'TOP' | 'BOTTOM';
  max_height?: string;
  image_size?: number;
}

export enum TextAndImageViewType {
  DEFAULT = 'DEFAULT',
  WITHOUT_BACKGROUND = 'WITHOUT_BACKGROUND'
}